import { render, staticRenderFns } from "./BajaEdit.vue?vue&type=template&id=f26c1ae2&"
import script from "./BajaEdit.vue?vue&type=script&lang=js&"
export * from "./BajaEdit.vue?vue&type=script&lang=js&"
import style0 from "./BajaEdit.vue?vue&type=style&index=0&id=f26c1ae2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports